.root {
  margin: 0;
  font-family: var(--font-sans);
  text-wrap: balance;
}

// Five distinct steps. Previously h4 and h5 rendered identically, which meant
// two of six levels were indistinguishable and levels got picked by eye.

// xl: page titles
.xl {
  font-size: var(--text-3xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text);
  letter-spacing: -0.02em;
  line-height: 1.15;
  margin-bottom: var(--space-6);
}

// lg: major section headers
.lg {
  font-size: var(--text-xl);
  font-weight: var(--font-weight-medium);
  color: var(--text);
  letter-spacing: -0.01em;
  line-height: 1.25;
  margin-bottom: var(--space-4);
}

// md: subsection headers
.md {
  font-size: var(--text-lg);
  font-weight: var(--font-weight-medium);
  color: var(--text);
  line-height: 1.3;
  margin-bottom: var(--space-3);
}

// sm: form section and card headers
.sm {
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
  color: var(--text-secondary);
  line-height: 1.4;
  margin-bottom: var(--space-2);
}

// xs: smallest labels
.xs {
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.4;
  margin-bottom: var(--space-1);
}
